"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _mergeClasses.default;
  }
});

var _mergeClasses = _interopRequireDefault(require("./mergeClasses"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/mergeClasses/index.js
// module id = 113
// module chunks = 0